<div mat-dialog-content>
  Quieres borrar el tag?
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close type="button" (click)="onCancel()">Cancelar</button>
  <button mat-button mat-dialog-close type="button" (click)="onConfirm()">Confirmar</button>
</div>